import styled from 'styled-components';
import { BASE_CLASSNAME } from '../enum';
/**
 * This component is used when a variant is not registered.
 */
export const FallbackComponent = styled.p.attrs({
    className: BASE_CLASSNAME,
}) ``;
//# sourceMappingURL=FallbackComponent.js.map